<div class="row text-dark">
	<div class="col-12 text-center fw-bold" [class.text-strike]="isDeleted">
		{{ historyData?.longName || historyData?.columnName }}
	</div>
	<div
		*ngIf="!!before"
		class="col-5 bg-light d-flex justify-content-center text-container"
		[ngClass]="{
			expand: before ? before.length > maxVisibleChars : false,
			'p-3': !before || before ? before < maxVisibleChars : false
		}"
	>
		<div class="text-content">
			<span
				class="align-self-center text-center text-break"
				[class.text-strike]="isDeleted"
				[innerText]="before"
			></span>
		</div>
	</div>
	<div *ngIf="!before" class="col-5"></div>
	<div class="col-2 d-flex flex-column justify-content-center">
		<i class="align-self-center" nstarIcon>next</i>
	</div>
	<div
		class="col-5 bg-light d-flex flex-column justify-content-center text-container"
		[ngClass]="{
			expand: after ? after.length > maxVisibleChars : false,
			'p-3': !after || after ? after < maxVisibleChars : false
		}"
	>
		<div class="text-content">
			<ng-container *ngIf="showDifference && !isDeleted; else showValueTemp">
				<div
					class="align-self-center text-center text-break"
					historyDiff
					[oldValue]="before"
					[newValue]="after"
				></div>
			</ng-container>
			<ng-template #showValueTemp>
				<span
					class="align-self-center text-center text-break"
					[class.text-strike]="isDeleted"
					[innerText]="after"
				></span>
			</ng-template>
		</div>
	</div>
</div>
